import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';

interface TabPanelProps {
  children: React.ReactNode;
  index: number;
  value: number;
}

export default function BasicTabs({ contentTab1 }) {
  function TabPanel(props: TabPanelProps) {
    const {
      children, value, index, ...other
    } = props;

    return (
      <div
        role='tabpanel'
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}>
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tab
          label='Informações'
          {...a11yProps(0)}
          sx={{
            textTransform: 'none',
            color: '#353e52',
            fontSize: '1.5rem',
            fontFamily: 'Barlow, sans-serif',
          }}
        />
      </Box>
      <TabPanel
        value={0}
        index={0}>
        {contentTab1}
      </TabPanel>
    </Box>
  );
}
